// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"f487ebc8","275":"9f49b13c","903":"e44674bc"}[chunkId] + ".chunk.js";
};